import { arktypeResolver } from '@hookform/resolvers/arktype';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { GroupFormFields } from '@/components/organisms/GroupFormFields';
import { useFormWithErrors } from '@/hooks/useFormWithErrors';
import { useTranslator } from '@/hooks/useTranslator';
import { GroupFormData, groupSchema } from '@/schemas/group';

interface Props {
  readonly initialValues?: Partial<GroupFormData>;

  onSubmit(data: GroupFormData): void;
}

export const CreateGroupForm: React.FC<Props> = (props: Props): React.ReactElement => {
  const { onSubmit, initialValues } = props;

  const tr = useTranslator();
  const form = useFormWithErrors<GroupFormData>({
    resolver: arktypeResolver(groupSchema),
    defaultValues: {
      groupName: initialValues?.groupName ?? '',
      description: initialValues?.description ?? '',
      roles: initialValues?.roles ?? [],
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = form;

  const handleFormSubmit = React.useCallback(
    (data: GroupFormData): void => {
      onSubmit?.(data);
    },
    [onSubmit],
  );

  return (
    <Box component="form" onSubmit={handleSubmit(handleFormSubmit)}>
      <GroupFormFields form={form} loading={isSubmitting} />

      <Box mt={6}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth={true}
          disabled={isSubmitting}>
          {tr('ADD')}
        </Button>
      </Box>
    </Box>
  );
};
